import React, { useEffect, useState } from 'react'
import './App.sass'

import './index.scss'

import DashDefault from './views/Dashboard/Dashboard'
import { SideBar } from './shared/sidebar'
import Monitoring from './views/Monitoring/Monitoring'

import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation
} from 'react-router-dom'
import Login from './views/Auth/Login'
import VisitorsList from './views/VisitorList/Visitors'
import CreateUser from './views/Auth/CreateUser'
import EditUser from './views/Auth/EditUser'
import Approvers from './Approvers/Approvers'
import Reports from './views/Reports/Reports'
import TicketControl from './views/TicketControl/TicketControl'
import {
  applyCurrentCompanyTheme,
  hasAuthenticatedSession,
  hasUsableAuthenticatedSession
} from './config/session'
import {
  recoverAuthenticatedSession,
  syncPreventiveSessionRefresh
} from './config/authFlow'

function ThemeSync() {
  const location = useLocation()

  useEffect(() => {
    applyCurrentCompanyTheme()
  }, [location.pathname, location.search])

  return null
}

function ProtectedRoute({ children }: { children: React.ReactElement }) {
  const [isCheckingSession, setIsCheckingSession] = useState(true)
  const [isAllowed, setIsAllowed] = useState(false)

  useEffect(() => {
    let isMounted = true

    const validateSession = async () => {
      if (!hasUsableAuthenticatedSession()) {
        if (!hasAuthenticatedSession()) {
          if (!isMounted) return
          setIsAllowed(false)
          setIsCheckingSession(false)
          return
        }

        const recovered = await recoverAuthenticatedSession()

        if (!isMounted) return

        if (!recovered) {
          setIsAllowed(false)
          setIsCheckingSession(false)
          return
        }
      }

      setIsAllowed(true)
      setIsCheckingSession(false)
    }

    validateSession()

    return () => {
      isMounted = false
    }
  }, [])

  if (isCheckingSession) {
    return (
      <div className="auth-wrapper">
        <div className="auth-content text-center">
          <div className="mb-3 spinner-border text-success" role="status" />
          <p className="mb-0">Validando sua sessao...</p>
        </div>
      </div>
    )
  }

  if (!isAllowed) {
    return <Navigate to="/" replace />
  }

  return children
}

function ProtectedLayout({ children }: { children: React.ReactElement }) {
  return (
    <ProtectedRoute>
      <>
        <SideBar />
        <div className="pcoded-main-container">
          <div className="pcoded-content">{children}</div>
        </div>
      </>
    </ProtectedRoute>
  )
}

function App() {
  useEffect(() => {
    syncPreventiveSessionRefresh()
  }, [])

  return (
    <>
      {/* <DashDefault /> */}
      <BrowserRouter>
        <ThemeSync />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedLayout>
                <DashDefault />
              </ProtectedLayout>
            }
          />
          <Route
            path="/control"
            element={
              <ProtectedRoute>
                <TicketControl />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitoring"
            element={
              <ProtectedLayout>
                <Monitoring />
              </ProtectedLayout>
            }
          />
          <Route
            path="/reporting"
            element={
              <ProtectedLayout>
                <Reports />
              </ProtectedLayout>
            }
          />
          <Route
            path="/visitors"
            element={
              <ProtectedLayout>
                <VisitorsList />
              </ProtectedLayout>
            }
          />
          <Route
            path="/user/create"
            element={
              <ProtectedLayout>
                <CreateUser />
              </ProtectedLayout>
            }
          />
          <Route
            path="/approvers"
            element={
              <ProtectedLayout>
                <Approvers />
              </ProtectedLayout>
            }
          />
          <Route
            path="/user/edit/:id"
            element={
              <ProtectedLayout>
                <EditUser />
              </ProtectedLayout>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App
